import { render, staticRenderFns } from "./DomainHostingOnlyWizard.vue?vue&type=template&id=217a3761&"
import script from "./DomainHostingOnlyWizard.vue?vue&type=script&lang=js&"
export * from "./DomainHostingOnlyWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports